import React, { PureComponent } from "react";
import { connect } from "react-redux";

import {
  Container,
  Wrapper,
  KeyboardView,
  Copy,
  Spin
} from "app/NativeComponents/common";
import MessageHeader from "./MessageHeader";
import MessageConversation from "app/DealMachineCore/snippets/MessageConversation";
import MessageAndNoteBox from "app/DealMachineCore/snippets/MessageAndNoteBox";
import KeyboardAwarePanel from "app/NativeComponents/components/KeyboardAwarePanel";

import {
  appRedirect,
  setActiveConversation,
  toggleConversationLeadView,
  toggleActionSheet,
  sendTextMessage,
  postMessageNote,
  updateConversation,
  checkIfUserHasModule
} from "app/NativeActions";

class Conversation extends PureComponent {
  constructor(props) {
    super(props);

    const plan_module_info = checkIfUserHasModule({
      plan_modules: props.plan_modules,
      user: props.user,
      slug: "messages"
    });
    this.state = {
      plan_module_info: plan_module_info
    };
  }

  componentDidMount() {
    if (
      !this.props.active_conversation &&
      this.props.token &&
      this.props.user
    ) {
      if (this.props.device == "desktop") {
        this.props.setActiveConversation({
          token: this.props.token,
          conversation: {
            id: this.props.match.params.id
          }
        });
      } else if (this.props.device == "mobile") {
        if (
          this.props.navigation &&
          this.props.navigation.state &&
          this.props.navigation.state.params &&
          this.props.navigation.state.params.conversation_id
        ) {
          this.props.setActiveConversation({
            token: this.props.token,
            conversation: {
              id: this.props.navigation.state.params.conversation_id
            }
          });
        }
      } else {
        this.props.setActiveConversation({ conversation: null });
      }
    } else {
      if (this.props.device == "mobile") {
        if (
          this.props.navigation &&
          this.props.navigation.state &&
          this.props.navigation.state.params &&
          this.props.navigation.state.params.conversation_id
        ) {
          this.props.setActiveConversation({
            token: this.props.token,
            conversation: {
              id: this.props.navigation.state.params.conversation_id
            }
          });
        }
      }
    }

    if (
      this.state.plan_module_info &&
      (!this.state.plan_module_info.has_module ||
        this.props.card_info.bad_card == 1)
    ) {
      this.props.appRedirect({
        redirect: "message_engine"
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {}
  componentWillUnmount() {
    if (this.props.device == "desktop") {
      this.props.setActiveConversation({ conversation: null });
    }

    clearInterval(this._message_interval);
  }
  renderConversation() {
    if (this.props.active_conversation_loading) {
      return (
        <Wrapper
          style={{
            padding: 20,
            alignItems: "center",
            justifyContent: "center",
            flex: 1
          }}
        >
          <Spin size="small" />
        </Wrapper>
      );
    }

    return (
      <MessageConversation
        is_expanded={true}
        selected_to_number={this.props.set_to_phone_number}
        selected_conversations={this.props.active_conversation}
        style={{
          padding: 10,
          backgroundColor: this.props.colors.card_color
        }}
        {...this.props}
      />
    );
  }

  renderMessageBox() {
    if (!this.props.active_conversation_loading) {
      return (
        <MessageAndNoteBox
          box_tab={"message"}
          selected_conversations={this.props.active_conversation}
          include_tabs={
            this.props.active_conversation &&
            this.props.active_conversation.length > 0
          }
          disabled={
            !this.props.set_to_phone_number ||
            (this.props.set_to_phone_number &&
              this.props.set_to_phone_number.blocked == 1) ||
            (this.props.set_to_phone_number &&
              this.props.set_to_phone_number.do_not_call == 1) ||
            (this.props.set_to_phone_number &&
              this.props.set_to_phone_number.landline == 1) ||
            (this.props.set_to_phone_number &&
              this.props.set_to_phone_number.bad_phone == 1) ||
            (this.props.active_conversation &&
              this.props.active_conversation.length > 0 &&
              this.props.active_conversation[0].awaiting_response_lock_out ==
                1) ||
            (this.props.active_conversation &&
              this.props.active_conversation.length > 0 &&
              this.props.active_conversation[0].timezone_lock_out == 1)
          }
          onNoteSubmit={({ message, onSuccess = null }) => {
            const { token, active_property } = this.props;
            if (message.trim().length > 0) {
              this.props.postMessageNote({
                token,
                message_text: message,
                lead_id:
                  this.props.active_conversation &&
                  this.props.active_conversation.length > 0
                    ? this.props.active_conversation[0].lead_id
                    : null,
                user: this.props.user,
                to_phone_number: this.props.set_to_phone_number
                  ? this.props.set_to_phone_number.phone_number
                  : null,
                conversation_id:
                  this.props.active_conversation &&
                  this.props.active_conversation.length > 0
                    ? this.props.active_conversation[0].id
                    : null
              });

              if (onSuccess) {
                onSuccess();
              }
            }
          }}
          onMessageSubmit={({ message, selected_from_number, onSuccess }) => {
            const { token, active_property } = this.props;
            if (message.trim().length > 0) {
              this.props.sendTextMessage({
                token,
                message_text: message,
                media: null,
                lead_id:
                  this.props.active_conversation &&
                  this.props.active_conversation.length > 0
                    ? this.props.active_conversation[0].lead_id
                    : null,
                conversation_id:
                  this.props.active_conversation &&
                  this.props.active_conversation.length > 0
                    ? this.props.active_conversation[0].id
                    : null,
                to_phone_number: this.props.set_to_phone_number
                  ? this.props.set_to_phone_number.phone_number
                  : null,
                to_phone_number_id: this.props.set_to_phone_number
                  ? this.props.set_to_phone_number.owner_phone_number_id
                  : null,
                from_phone_number: selected_from_number
                  ? selected_from_number.id
                  : null
              });

              if (onSuccess) {
                onSuccess();
              }
            }
          }}
          selected_from_number={this.props.set_from_phone_number}
        />
      );
    }
  }

  render() {
    if (
      this.props.user &&
      this.props.active_conversation &&
      this.props.active_conversation != "conversation_settings" &&
      this.props.active_conversation != "manage_phone_numbers" &&
      this.props.active_conversation != "manage_saved_replies" &&
      this.props.active_conversation.length > 0
    ) {
      return (
        <Container fill>
          <KeyboardAwarePanel style={{ height: "100%" }}>
            <MessageHeader {...this.props} />
            {this.renderConversation()}
            {this.renderMessageBox()}
          </KeyboardAwarePanel>
        </Container>
      );
    }

    return <Wrapper />;
  }
}

const mapStateToProps = ({ auth, native, settings, billing, message }) => {
  const { token, user } = auth;
  const { device, isMobile, platform, isIphoneX } = native;
  const { colors } = settings;
  const { plan_modules, card_info } = billing;
  const {
    active_conversation,
    active_conversation_loading,
    set_to_phone_number,
    set_from_phone_number,
    toggle_conversation_lead_view,
    update_conversation_loading
  } = message;

  return {
    token,
    user,
    device,
    isMobile,
    platform,
    isIphoneX,
    colors,

    active_conversation,
    active_conversation_loading,
    set_to_phone_number,
    set_from_phone_number,
    toggle_conversation_lead_view,
    update_conversation_loading,
    plan_modules,
    card_info
  };
};

export default connect(mapStateToProps, {
  appRedirect,
  setActiveConversation,
  toggleConversationLeadView,
  toggleActionSheet,
  sendTextMessage,
  postMessageNote,
  updateConversation
})(Conversation);
